//@file Bundle images based on wall type for homepage
import { __ } from 'bits/intl'
import freePreviewLandscape from 'images/free_preview_landscape.png'
import freePreviewPortrait from 'images/free_preview_portrait.png'
import gridPreviewLandscape from 'images/grid_preview_landscape.png'
import gridPreviewPortrait from 'images/grid_preview_portrait.png'
import mapPreviewLandscape from 'images/map_preview_landscape.png'
import mapPreviewPortrait from 'images/map_preview_portrait.png'
import matrixPreviewLandscape from 'images/matrix_preview_landscape.png'
import matrixPreviewPortrait from 'images/matrix_preview_portrait.png'
import shelfPreviewLandscape from 'images/shelf_preview_landscape.png'
import shelfPreviewPortrait from 'images/shelf_preview_portrait.png'
import streamPreviewLandscape from 'images/stream_preview_landscape.png'
import streamPreviewPortrait from 'images/stream_preview_portrait.png'
import timelinePreviewLandscape from 'images/timeline_preview_landscape.png'
import timelinePreviewPortrait from 'images/timeline_preview_portrait.png'

interface Format {
  title: string
  description: string
  previewImageLandscapeSrc: string
  previewImagePortraitSrc: string
  vectorImageSrc: string
  altTag: string
}

interface FormatCollection {
  [key: string]: Format
}

const formats: FormatCollection = {
  grid: {
    title: __('Wall'),
    description: '',
    previewImageLandscapeSrc: gridPreviewLandscape,
    previewImagePortraitSrc: gridPreviewPortrait,
    vectorImageSrc: '',
    altTag: __(
      'The wall layout produces a compact layout so posts appear at random. New posts are added in empty spaces first but you can change locations by dragging them into position.',
    ),
  },
  free: {
    title: __('Canvas'),
    description: '',
    previewImageLandscapeSrc: freePreviewLandscape,
    previewImagePortraitSrc: freePreviewPortrait,
    vectorImageSrc: '',
    altTag: __(
      'In the canvas format, entries are placed at random and can be rearranged on the padlet by those with admin access. Connectors give you an option to connect posts via arrows.',
    ),
  },
  shelf: {
    title: __('Shelf'),
    description: '',
    previewImageLandscapeSrc: shelfPreviewLandscape,
    previewImagePortraitSrc: shelfPreviewPortrait,
    vectorImageSrc: '',
    altTag: __('The shelf layout allows you to stack your content in a series of sections.'),
  },
  stream: {
    title: __('Stream'),
    description: '',
    previewImageLandscapeSrc: streamPreviewLandscape,
    previewImagePortraitSrc: streamPreviewPortrait,
    vectorImageSrc: '',
    altTag: __(
      'In the stream layout, posts are arranged in a vertical stream, from most recent (top) to oldest (bottom).',
    ),
  },
  matrix: {
    title: __('Grid'),
    description: '',
    previewImageLandscapeSrc: matrixPreviewLandscape,
    previewImagePortraitSrc: matrixPreviewPortrait,
    vectorImageSrc: '',
    altTag: __(
      'In the Grid layout, posts are arranged in boxes of equal width and space apart.Image previews can be arranged by dragging posts on the column you need them to be.',
    ),
  },
  timeline: {
    title: __('Timeline'),
    description: '',
    previewImageLandscapeSrc: timelinePreviewLandscape,
    previewImagePortraitSrc: timelinePreviewPortrait,
    vectorImageSrc: '',
    altTag: __(
      'Timelines allow you to visualize information in points on a line that makes changes across time much easier to see.',
    ),
  },
  map: {
    title: __('Map'),
    description: '',
    previewImageLandscapeSrc: mapPreviewLandscape,
    previewImagePortraitSrc: mapPreviewPortrait,
    vectorImageSrc: '',
    altTag: __('The map layout allows you to add content to points on a map.'),
  },
}

export { formats, Format }
